import type { AnswerState } from '@repo/contracts/cardfinder/funnel/types';
import { ENTRY_STEP_ID } from '@/shared/config/funnel/flowConstants';

/** A primary-goal pick alone isn't enough intent to save. */
export function isPastFirstQuestion(answers: AnswerState): boolean {
  return Object.keys(answers).some(stepId => stepId !== ENTRY_STEP_ID);
}
